import React, {Component} from "react";
import styles from "./FJMusicRefresh.module.less";
import InlineSVG from "react-inlinesvg";
import RefreshIcon from "../../../../../icon/refresh.svg";
import classNames from 'classnames';

class FJMusicRefresh extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isRefreshing: false,
		}
	}

	onRefresh = (e) => {
		e.stopPropagation();
		if (!this.state.isRefreshing) {
			this.setState({
				isRefreshing: true,
			}, () => {
				if (this.props.refreshCallback) {
					this.props.refreshCallback();
				}
			});
		}
	}


	render() {

		let {
			active
		} = this.props;

		return (
			<div className={classNames(styles.refresh_container, {[styles.active]: active})} onClick={this.onRefresh}>
				<div className={classNames(styles.refresh_content, {[styles.rotate]: this.state.isRefreshing})}>
					<InlineSVG src={RefreshIcon}/>
				</div>
			</div>
		)
	}

}

export default FJMusicRefresh;